import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        @for (item of model; track $index; let i = $index) {
            @if (!item.separator) {
                <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
            }
            @else {
                <li class="menu-separator"></li>
            }
        }
    </ul> `
})
export class AppMenu {
    model: MenuItem[] = [];

    ngOnInit() {
        this.model = [
            {
                label: '',
                items: [{ label: 'Tableau de bord', icon: 'pi pi-fw pi-home', routerLink: ['/'] }]
            },
            {
                label: 'Produits',
                items: [
                    { label: 'Recherche', icon: 'pi pi-fw pi-search', routerLink: ['/products'] },
                    { label: 'Ajouter un produit', icon: 'pi pi-fw pi-plus', routerLink: ['/products', 'ajouter'] },
                    { label: 'Inventaire', icon: 'pi pi-fw pi-inbox', disabled: true },
                    {
                        label: 'Marques',
                        icon: 'pi pi-fw pi-cog',
                        items: [
                            { label: 'Liste des marques', icon: 'pi pi-fw pi-list', routerLink: ['/marques'] },
                            { label: 'Ajouter une marque', icon: 'pi pi-fw pi-plus', routerLink: ['/marques'], fragment: 'add' },
                        ]
                    },
                    { label: 'Erreurs EBP',icon: 'pi pi-fw pi-exclamation-triangle',routerLink: ['/ebp'] },
                ]
            },
            {
                label: 'Ebay',
                items: [
                    { label: 'Écarts de prix',icon: 'pi pi-fw pi-percentage',routerLink: ['/ebay'] },
                    { label: 'Boutiques Ebay',icon: 'pi pi-fw pi-shop',routerLink: ['/ebay/shops'] },
                    { label: 'Produits modifiés post-Ebay',icon: 'pi pi-fw pi-pencil',routerLink: ['/ebay/modified'] },
                    { label: 'Recherches personnalisées',icon: 'pi pi-fw pi-search',routerLink: ['/ebay/search'] },
                ]
            }
            // {
            //     label: 'Hierarchy',
            //     items: [
            //         {
            //             label: 'Submenu 1',
            //             icon: 'pi pi-fw pi-bookmark',
            //             items: [
            //                 {
            //                     label: 'Submenu 1.1',
            //                     icon: 'pi pi-fw pi-bookmark',
            //                     items: [
            //                         { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
            //                         { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
            //                         { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' }
            //                     ]
            //                 },
            //                 {
            //                     label: 'Submenu 1.2',
            //                     icon: 'pi pi-fw pi-bookmark',
            //                     items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }]
            //                 }
            //             ]
            //         },
            //         {
            //             label: 'Submenu 2',
            //             icon: 'pi pi-fw pi-bookmark',
            //             items: [
            //                 {
            //                     label: 'Submenu 2.1',
            //                     icon: 'pi pi-fw pi-bookmark',
            //                     items: [
            //                         { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
            //                         { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' }
            //                     ]
            //                 },
            //                 {
            //                     label: 'Submenu 2.2',
            //                     icon: 'pi pi-fw pi-bookmark',
            //                     items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }]
            //                 }
            //             ]
            //         }
            //     ]
            // }
        ];
    }
}
